<template>
  <div id="footer" class="container-fluid">
    <div style="margin-top: 30px"> 北京洞察力科技股份有限公司 版权所有</div>
    <div style="margin-top: 10px;margin-right: 4px">证书编号：(京)-非经营性-2022-0038
       <a style="color: #fff;display: inline-block;margin-left: 10px" href="https://beian.miit.gov.cn/" target="_blank">京ICP备14040817号-1</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
.container-fluid {
  width: 100%;
  height: 100px;
  color: #fff;
  background: #5C5C5C;
  overflow: hidden;
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
}
/*@media screen and (min-width: 768px) and (max-width: 996px) {*/
/*  #footer {*/
/*    width: 100%;*/
/*    height: 180px;*/
/*    color: #fff;*/
/*    background: #D83D22;*/
/*    overflow: hidden;*/
/*    text-align: center;*/
/*    font-size: 16px;*/
/*    line-height: 180px;*/
/*  }*/
/*}*/
/*!* 媒体查询（手机） *!*/
/*@media screen and (max-width: 768px) {*/
/*  #footer {*/
/*    width: 100%;*/
/*    height: 120px;*/
/*    color: #fff;*/
/*    background: #D83D22;*/
/*    overflow: hidden;*/
/*    text-align: center;*/
/*    font-size: 12px;*/
/*    line-height: 120px;*/
/*  }*/

/*}*/

</style>




// WEBPACK FOOTER //
// src/components/Footer.vue